import React, { useState } from 'react'
import '../../Style/Table4.css'
import MaterialTable from 'material-table'
import AddIcon from '@material-ui/icons/Add'
import { Button, Grid } from '@material-ui/core'
import { Modal33 } from '../../Modals/ModalSec3/Modal33'
import { Modal33Edit } from '../../Modals/ModalSec3Edit/Modal33Edit'
import { deleteProductionAndLosses } from '../../../../../services/Elegibilidad/delete'
import swal from 'sweetalert'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import NumberFormat from 'react-number-format'

const Table33 = ({ getDataTableProductionAndLoss, tableProductionandLoss }) => {
  const [body, setBody] = useState({})
  const [openEdit, setOpenEdit] = useState(false)

  const handleDelete = async (id) => {
    try {
      const response = await deleteProductionAndLosses(id)

      if (response.Success) {
        swal({
          title: '¡Registro eliminado exitosamente!',
          icon: 'success',
        })
        getDataTableProductionAndLoss()
      }
    } catch (error) {
      console.log(error)
    }
  }

  const columns = [
    // {
    //   title: 'Código',
    //   field: 'IdProductionAndLosseByClimate',
    //   sorting: false,
    //   filtering: false,
    //   // cellStyle: { background: '#009688' },
    //   // headerStyle: { color: '#fff' },
    // },
    {
      title: 'Rubro / Producto',
      field: 'Area',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Categoría',
      field: 'CategoryDesc',
      filtering: false,
      align: 'center',
    },
    {
      title: 'Cantidad de hectáreas que posee la MIPYME',
      field: 'Hectares',
      align: 'center',
      grouping: false,
      filtering: false,
      render: (expense) => (
        <NumberFormat
          value={expense.Hectares}
          thousandSeparator={true}
          decimalScale={2}
          displayType={'text'}
          isNumericString={true}
          fixedDecimalScale
        />
      ),
    },

    {
      title: 'Cantidad de hectáreas que formarán parte del subproyecto',
      field: 'SubProjectHectares',
      align: 'center',
      filtering: false,
      render: (expense) => (
        <NumberFormat
          value={expense.SubProjectHectares}
          thousandSeparator={true}
          decimalScale={2}
          displayType={'text'}
          isNumericString={true}
          fixedDecimalScale
        />
      ),
    },
  ]

  const [openSec33, setOpenSec33] = useState(false)

  return (
    <div className="App">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={tableProductionandLoss}
            actions={[
              {
                icon: () => (
                  <Button
                    variant="contained"
                    color="success"
                    style={
                      tableProductionandLoss.length < 5
                        ? { backgroundColor: '#27C27D', color: '#FFFFFF' }
                        : {}
                    }
                    startIcon={<AddIcon style={{ color: 'white' }} />}
                    disabled={tableProductionandLoss.length >= 5}
                    onClick={() => {
                      setOpenSec33(true)
                    }}
                  >
                    Agregar registro
                  </Button>
                ),
                tooltip: 'Agregar',
                position: 'toolbar',
              },
              {
                icon: () => <EditIcon style={{ color: '#0d53ad' }} />,
                tooltip: 'Editar',
                onClick: (event, rowData) => {
                  setOpenEdit(true)
                  setBody(rowData)
                },
              },
              {
                icon: () => <DeleteIcon style={{ color: 'red' }} />,
                tooltip: 'Eliminar registro',
                onClick: (event, rowData) => {
                  swal({
                    title: '¿Está seguro de eliminar el registro?',
                    icon: 'warning',
                    buttons: ['No', 'Si'],
                    dangerMode: true,
                  }).then(function (isConfirm) {
                    if (isConfirm) {
                      handleDelete(rowData.IdProductionAndLosseByClimate)
                    }
                  })
                },
              },
            ]}
            onSelectionChange={(selectedRows) => console.log(selectedRows)}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: true,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',

              exportFileName: 'TableData',
              addRowPosition: 'first',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              toolbarButtonAlignment: 'left',
              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),
              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
            // icons={{ Add: () => <AddIcon /> }}
          />
        </Grid>
      </Grid>
      <Modal33
        openSec33={openSec33}
        setOpenSec33={setOpenSec33}
        getDataTableProductionAndLoss={getDataTableProductionAndLoss}
        data={tableProductionandLoss}
      />
      <Modal33Edit
        open={openEdit}
        setOpen={setOpenEdit}
        body={body}
        setBody={setBody}
        getDataTableProductionAndLoss={getDataTableProductionAndLoss}
        data={tableProductionandLoss}
      />
    </div>
  )
}

export default React.memo(Table33)
